// import Axios
import Axios from 'axios';

import vuex from './vuex';
import storage from './storage';
import logger from "./logger.js";

// instantiate axios
const axios = Axios.create();

// before each request
// add the current token to the next request header
axios.interceptors.request.use(async config => {
    let token = await storage.getToken();
    if (token) {
        config.headers.Authorization = token;
    }
    return config;
}, error => {
    return Promise.reject(error);
});

axios.interceptors.response.use(response => {
    return response;
}, error => {

    if(error.response) {
        let url = error.response.config.url?error.response.config.url:'';
        let status = error.response.status;
        let message = error.response.data.message ? error.response.data.message : error.response.data.error.message;
        logger.error(`url: ${url}, status: ${status}, message: ${message}`, error.stack)
          .then(() => null)
        // logout user if we specifically receive an unauthorized response saying we have expired
        if (error.response.status === 403 && error.response.data.status === 'expired') {
            vuex.dispatch('account/logout');
        }

        // if we receive a response with a 500 error dispatch an alert with the error message
        if (error.response.status === 500) {
            vuex.dispatch('alert/error', 'Oops, something went wrong.', {root: true});
        }
    } else {
        logger.error(error.message, error.stack)
                .then(() => null);
        console.log('Oops, something went horribly wrong.', error);
    }

    return Promise.reject(error);
});

export default axios;
